import React from "react";
import { TextField } from '@mui/material';


export const APISelectField = (props) => {
    const {
        errors = [], 
        label='', 
        children, 
        value, 
        onChange,
        name,
        disabled = false,
        sx = {m: 1, minWidth: 120},
        variant = "standard",
    } = props;

    let errMsg = ""
    
    if (errors.length > 0) {
        errMsg = errors.map(({message}) => `${message}`).reduce((msg1, msg2) => `${msg1}\n${msg2}`)
    }

    return (
        
            <TextField 
                name={name}
                select
                defaultValue={""}
                label={label}
                sx={sx} 
                error={!!errMsg}
                helperText={errMsg}
                variant={variant}
                renderValue={
                    errMsg ? (value) => `⚠️  - ${value}` : value
                }
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
            {children}
            </TextField>
    )
}